import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';

const CO_DENY_RESOURCE = 'coDenyImpersonation';
const ORG_IMPERSONATION_RESOURCE = 'orgImpersonationRequests';

const coDenyImpersonationService = ComposedComponent =>
  reduxFetch([
    {
      resource: CO_DENY_RESOURCE,
      method: 'put',
      request: (id, body, callback, t) => ({
        url: apiRoutes.coDenyImpersonation(id),
        body,
        meta: {
          removeFromOtherList: {
            resource: ORG_IMPERSONATION_RESOURCE,
            idProp: 'id',
            id,
          },
          callback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'coDenyImpersonationFailed'),
            onSuccessMessage: t('coDenyImpersonationSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default coDenyImpersonationService;
